import {
  helpers,
  required,
  minLength,
  maxLength,
  numeric,
  email
} from "vuelidate/lib/validators";

const name = helpers.regex("name", /^[_A-z]*((-|\s)*[_A-z])*$/);
const phoneNumber = helpers.regex(
  "phoneNumber",
  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
);

const validations = {
  fname: { required, name, min: minLength(2) },
  lname: { required, name, min: minLength(2) },
  address: { min: minLength(5) },
  city: { name, min: minLength(2) },
  postalCode: { required, numeric, min: minLength(5), max: maxLength(5) },
  phone: { phoneNumber, min: minLength(10) },
  email: { email, min: minLength(5) }
};

const esrules = {
  fnameRules: [
    v => !!v || "Se requiere el primer nombre",
    v =>
      (v && /^[_A-z]*((-|\s)*[_A-z])*$/.test(v)) ||
      "El nombre solo debe contener letras"
  ],
  lnameRules: [
    v => !!v || "Se requiere apellido",
    v =>
      (v && /^[_A-z]*((-|\s)*[_A-z])*$/.test(v)) ||
      "El apellido solo debe contener letras"
  ],
  streetAddressRules: [
    v =>
      (v && v.length >= 5) || "La dirección debe contener al menos 5 caracteres"
  ],
  cityRules: [
    v => (v && v.length >= 2) || "La ciudad debe contener al menos 2 caracteres"
  ],
  phoneRules: [
    v =>
      (v && /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v)) ||
      "El número de teléfono debe ser válido",
    v =>
      (v && v.length >= 10) ||
      "El número de teléfono debe contener al menos 10 caracteres"
  ],
  emailRules: [
    v => (v && /.+@.+/.test(v)) || "El correo electrónico debe ser válido",
    v =>
      (v && v.length >= 5) ||
      "El correo electrónico debe contener al menos 5 caracteres"
  ],
  postalCodeRules: [
    v => !!v || "Se requiere código postal",
    v =>
      (v && /^\d+$/.test(v)) || "El código postal solo debe contener números",
    v =>
      (v && v.length === 5) ||
      "El código postal debe tener exactamente 5 caracteres"
  ],
  messageBodyRules: [v => !!v || "No puede enviar un mensaje en blanco"]
};

export default {
  validations,
  esrules
};
